import ProfileSetting from '@/Component/Profile/ProfileSetting'
import Faq from '@/Component/Profile/ProfileSetting/Faq'

const PasswordSecurityPage = () => {
    return (
        <ProfileSetting activeTab="faq">
            <Faq />
        </ProfileSetting>
    )
}

export default PasswordSecurityPage
